import { __decorate } from "tslib";
import { Directive } from 'angular-ts-decorators';
import Typed from 'typed.js';
var LiveTypingDirective = (function () {
    function LiveTypingDirective() {
    }
    LiveTypingDirective.$inject = [];
    LiveTypingDirective = __decorate([
        Directive({
            link: function ($scope, $element) {
                if (!$scope.liveTypingText) {
                    return;
                }
                if (!$element.attr('id')) {
                    $element.attr('id', "typed-" + String(Math.random()).slice(2));
                }
                $scope.typed = new Typed("#" + $element.attr('id'), {
                    backSpeed: 0,
                    showCursor: false,
                    strings: [$scope.liveTypingText],
                    typeSpeed: 60,
                });
                $scope.$on('$destroy', function () {
                    var _a;
                    (_a = $scope.typed) === null || _a === void 0 ? void 0 : _a.destroy();
                });
                $scope.$on('resetLiveTyping', function () {
                    var _a;
                    (_a = $scope.typed) === null || _a === void 0 ? void 0 : _a.reset();
                });
            },
            scope: {
                liveTypingText: '<',
            },
            selector: '[liveTyping]',
        })
    ], LiveTypingDirective);
    return LiveTypingDirective;
}());
export { LiveTypingDirective };
